"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const RendererCoordinates = Object.freeze({
    POINT: "markerPixelIndex",
    POINT_CORRECTED: "markerPixelIndex_OutputImageCoordinates",
    START: "markerPixelIndexStart",
    FINISH: "markerPixelIndexFinish",
    START_CORRECTED: "markerPixelIndexStart_OutputImageCoordinates",
    FINISH_CORRECTED: "markerPixelIndexFinish_OutputImageCoordinates",
    UPPER_LEFT: "markerPixelIndexUL",
    LOWER_RIGHT: "markerPixelIndexLR",
    UPPER_LEFT_CORRECTED: "markerPixelIndexUL_OutputImageCoordinates",
    LOWER_RIGHT_CORRECTED: "markerPixelIndexLR_OutputImageCoordinates",
    POINTS: "markerPixelXIndices",
    POINTS_CORRECTED: "markerPixelIndices_OutputImageCoordinates"
});
const _default = RendererCoordinates;
